const moment = require('moment')

// Função auxiliar para gerar cores da marca
const generateBrandColors = () => {
    return {
        containerBg: 'from-gray-50/80 via-white/80 to-gray-50/80',
        overlayBg: 'from-brand-yellow/5 to-brand-yellow/5',
        decorationBg: 'from-brand-yellow/10 to-brand-yellow/10',
        border: 'border-brand-yellow/30',
        inputBorder: 'border-gray-200',
        focusRing: 'focus:ring-brand-yellow',
        iconBg: 'from-gray-900 via-gray-800 to-gray-900',
        textGradient: 'from-gray-900 via-gray-800 to-gray-900',
        buttonPrimary: 'from-brand-yellow via-brand-yellow to-brand-yellow-dark',
        buttonPrimaryHover: 'hover:from-brand-yellow-dark hover:via-brand-yellow-dark hover:to-brand-yellow-dark',
        buttonSecondaryBorder: 'border-gray-200',
        buttonSecondaryBg: 'from-white to-gray-50',
        buttonSecondaryBgHover: 'hover:from-gray-50 hover:to-gray-100',
        buttonSecondaryText: 'text-gray-700',
        buttonOverlay: 'from-brand-yellow/10 to-brand-yellow/10',
        focusRingOffset: 'focus:ring-brand-yellow',
        headerIconBg: 'bg-gray-900',
        headerIconText: 'text-brand-yellow',
        headerButtonBg: 'bg-brand-yellow',
        headerButtonHover: 'hover:bg-brand-yellow-dark'
    }
}

const brandColors = generateBrandColors()

export const colorMap = {
    indigo: brandColors,
    blue: brandColors,
    green: brandColors,
    purple: brandColors,
    pink: brandColors,
    red: brandColors,
    yellow: brandColors,
    emerald: brandColors,
    teal: brandColors,
    cyan: brandColors,
    orange: brandColors
}

export const perPageOptionsSearch = [
    { value: 1, label: '5 registros' },
    { value: 10, label: '10 registros' },
    { value: 20, label: '20 registros' },
    { value: 50, label: '50 registros' }
]

// Função para formatar data
export const formatDate = (dateString) => {
    if (!dateString) return '-'
    return moment(dateString).format('DD/MM/YYYY')
}

export const formatDateAnTime = (dateString) => {
    if (!dateString) return '-'
    const hour = new Date(dateString).toLocaleString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    const date = new Date(dateString).toLocaleDateString('pt-BR')
    return `${date} ${hour}`
}

// Função para truncar texto
export const truncate = (text, maxLength) => {
    if (!text) return '-'
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text
}

export const formatCPFOrCNPJ = (value) => {
    if (!value) return '-'
    if (value.length === 11) {
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
    }
    return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}


export const formatPhone = (value) => {
    if (!value) return '-'
    return value.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3')
}